import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { interval } from 'rxjs';
import { catchError, mapTo, tap } from 'rxjs/operators';
import { AppConfig } from './app-config.service';

@Injectable({
  providedIn: 'root',
})
export class ApiHealthService {
  private healthy?: boolean = undefined;
  private UNHEALTHY_STATUSES = [503, 504];

  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
    if (this.appConfig.config.healthCheck.enabled) {
      interval(1000)
        .pipe(tap(() => (this.healthy = undefined)))
        .subscribe();
    }
  }

  public async isApiHealthy(): Promise<boolean> {
    if (this.healthy !== undefined) {
      return this.healthy;
    }

    return this.httpClient
      .get(`${this.appConfig.config.healthCheck.actuatorUrl}/health`)
      .pipe(
        mapTo(true),
        catchError(async (err) => !err.status || !this.UNHEALTHY_STATUSES.includes(err.status)),
      )
      .toPromise();
  }
}
